/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { MyProfileListMode } from '@myprofile-ui/myprofile-phone-utils'

export class GetProfile {
  static readonly type = '[phone-widget] get profile'
}

export class GetPhones {
  static readonly type = '[phone-widget] get phones'
}

export class SelectPhone {
  static readonly type = '[phone-list] select phone'

  constructor(public selectedPhoneId: string) {}
}

export class SetPhoneBeingEdited {
  static readonly type = '[phone-form] set phone being edited'

  constructor(public phoneIdBeingEdited: string) {}
}

export class SetPhoneBeingVerified {
  static readonly type = '[phone-verification] set phone number being verified'

  constructor(
    public phoneNumberBeingVerified: {
      number: string
      section: MyProfileListMode
      preferred: boolean
      id?: string
      phoneType?: string
    } | null,
  ) {}
}

export class SetPhoneListDisabled {
  static readonly type = '[phone-list] set disabled phone list'

  constructor(public disabled: boolean) {}
}

export class SetListOverlayLoadingStatus {
  static readonly type = '[phone-list] set list overlay loading status'

  constructor(public loading: boolean) {}
}
